export default __webpack_public_path__ + "linkedin-sqr-v1.svg";